package com.artvending.warden.screens.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.artvending.warden.DateTimeUserData
import com.artvending.warden.Page
import com.artvending.warden.ScreenModel
import com.artvending.warden.MySettings
import com.artvending.warden.currentScreenModel
import com.artvending.warden.fixedInterval
import com.artvending.warden.getDayMinutes
import com.artvending.warden.launch
import com.artvending.warden.now
import com.artvending.warden.screens.history.HistoryScreenModel
import com.artvending.warden.screens.scanner.ScannerScreenModel
import kotlinx.coroutines.delay
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime


class HomeScreenModel() : ScreenModel() {
	var dateTimeUserData by mutableStateOf(DateTimeUserData.get())
	
	override val page: Page?
		get() = Page.HOME
	
	
	@Composable
	override fun Display(scope: Any?) {
		scope.HomeScreen(this)
	}
	
	
	fun go() {
		currentScreenModel = ScannerScreenModel()
	}
	
	
	fun getButtonColor() = if (fixedInterval?.from == null)
		MySettings.buttonColor1
	else
		if (fixedInterval?.to == null)
			MySettings.buttonColor2
		else
			MySettings.buttonColor3
	
	
	override fun enter() {
		var now = LocalDateTime.now()
		var currentMinute = now.getDayMinutes()
		
		launch {
			while(this == currentScreenModel) {
				val newDate = LocalDateTime.now()
				now = newDate
				val newCurrentMinute = now.getDayMinutes()
				
				if (newCurrentMinute != currentMinute) {
					currentMinute = newCurrentMinute
					dateTimeUserData = DateTimeUserData.get()
				}
				
				delay(500)
			}
		}
	}
	
	
	fun remarkClicked(date: LocalDate) {
		currentScreenModel = HistoryScreenModel(date)
	}
}


@Composable
expect fun Any?.HomeScreen(model: HomeScreenModel)